import { motion } from "framer-motion";
import { Facebook, Instagram, Linkedin, Github, Twitter } from "lucide-react";

const socialPlatforms = [
  { key: "facebook", icon: Facebook },
  { key: "twitter", icon: Twitter },
  { key: "instagram", icon: Instagram },
  { key: "linkedin", icon: Linkedin },
  { key: "github", icon: Github },
];

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
};

const TeamMemberCard = ({ name, role, image, description, socialLinks, onClick }) => {
  const truncatedDescription = truncateText(description, 120);

  const availableLinks = socialPlatforms.filter(
    (platform) => socialLinks && socialLinks[platform.key]
  );

  return (
    <motion.div
      className="bg-white rounded-2xl p-6 flex flex-col items-center text-center gap-3 shadow-sm hover:shadow-lg transition-shadow duration-300 border border-gray-100 cursor-pointer h-full"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      whileHover={{ scale: 1.02 }}
      onClick={onClick}
    >
      <div className="w-24 h-24 rounded-full border-[3px] border-[#6B8F8A] overflow-hidden">
        <img 
          src={image} 
          alt={name} 
          className="w-full h-full object-cover"
        />
      </div>

      <h3 className="text-lg font-bold text-[#6B8F8A]">{name}</h3>
      <p className="text-sm text-[#6b7280] font-medium">{role}</p>
      <p className="text-sm text-[#6b7280] leading-relaxed">{truncatedDescription}</p>

      {availableLinks.length > 0 && (
        <div className="flex items-center gap-3 mt-2">
          {availableLinks.map(({ key, icon: Icon }) => (
            <a
              key={key}
              href={socialLinks[key]}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#6b7280] hover:text-[#6B8F8A] transition-colors"
              aria-label={key}
              onClick={(e) => e.stopPropagation()}
            >
              <Icon className="w-4 h-4" />
            </a>
          ))}
        </div>
      )}
    </motion.div>
  );
};

export default TeamMemberCard;
